export * from './GiftCardsSubheadingTextWrapper';
